import { EM_DASH, formatIDR } from "~/lib/format";

/**
 * Minor units (sen) to Rupiah, by string arithmetic rather than division so a
 * large amount never passes through a float's rounding.
 */
export function formatMinorIDR(minor: number | null | undefined): string {
  if (minor == null) return EM_DASH;
  const negative = minor < 0;
  const digits = Math.abs(Math.trunc(minor)).toString().padStart(3, "0");
  const whole = digits.slice(0, -2);
  const fraction = digits.slice(-2);
  return formatIDR(`${negative ? "-" : ""}${whole}.${fraction}`);
}
